
import { DesktopNav } from "./navigation/desktop-nav";
import { MobileNav } from "./navigation/mobile-nav";
import { useLocation } from "react-router-dom";

interface NavigationProps {
  className?: string;
}

const Navigation = ({ className = '' }: NavigationProps) => {
  const location = useLocation();
  const isPrivacyPage = location.pathname === "/privacy";
  const isTermsPage = location.pathname === "/terms";
  const isHowToPlayPage = location.pathname === "/how-to-play";
  const isFaqPage = location.pathname === "/faq";
  const shouldShowBackground = isPrivacyPage || isTermsPage || isHowToPlayPage || isFaqPage;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 ${className} ${
      shouldShowBackground ? "bg-racing-dark/80 backdrop-blur-md" : ""
    }`}>
      <DesktopNav />
      <MobileNav />
    </header>
  );
};

export default Navigation;
